var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-chart',{attrs:{"check":false,"title":'Số lượng Cán bộ/Giảng viên',"sub-title1":'Tổng số CB/GV',"sub-title2":'Tổng số CB/GV tại trường',"data-card":_vm.dataEmployeeOverview}})}
var staticRenderFns = []

export { render, staticRenderFns }